import React from 'react'
import { Button as ButtonG } from 'grommet'
import styled from 'styled-components'
import { setLightness } from 'polished'
// import { isMobile } from 'react-device-detect'

import { cssVarPolished } from '../../utils/cssVarHelper'
import TipDrop from './TipDrop'

// const BadgeBox = styled(Box)`
//   position:relative;
//   &:after {
//     position:absolute;
//     right:-9px;
//     top:-10px;
//     min-width:10px;
//     min-height:10px;
//     line-height:10px;
//     padding:3px 5px;
//     color:#fff;
//     background-color:${props => props.theme.global.colors.secondary};
//     border: 1px solid white;
//     font-size:9px;
//     border-radius:20px;
//     content: '${props => props.badge}';
//     font-weight: 700;
//   }
// `
const Button = styled(ButtonG)`
  background-color: ${props => {
    return props.colorB !== ''
      ? setLightness(
          0.85,
          cssVarPolished(props.theme.global.colors[props.colorB], '#222'),
        )
      : 'transparent'
  }};
  border-radius: ${props => props.borderRadius};
  padding: ${props => props.padding};
`

const TooltipButton = ({
  clicked,
  message,
  icon,
  position,
  color = '',
  padding = '12px',
  inline = false,
  disabled = false,
  borderRadius = '50%',
}) => {
  return (
    <TipDrop content={message} position={position} inline={inline}>
      <Button
        colorB={color}
        icon={icon}
        onClick={clicked}
        padding={padding}
        disabled={disabled}
        borderRadius={borderRadius}
      />
    </TipDrop>
  )
}

export default TooltipButton
